/** Hero deck slides — overview copy only (no technology tiles). */
export const cardData = [
  {
    id: 1,
    name: "Overview",
    title: "One team from idea to operations",
    description:
      "We own delivery end to end: discovery, build, launch, and handover you can run — fewer handoffs, clearer accountability, and roadmaps you can plan against.",
  },
  {
    id: 2,
    name: "Engineering",
    title: "Software that survives real usage",
    description:
      "Product-minded development with sensible architecture, tests where they matter, and interfaces that stay legible as traffic and features grow.",
    cta: {
      href: "/service/product-oriented-delivery",
      text: "Engineering",
    },
  },
  {
    id: 3,
    name: "Design",
    title: "Design aligned with build",
    description:
      "UI, flows, and design systems shaped with engineering in the room — less rework, faster stakeholder feedback, and handoff that stays honest.",
    cta: {
      href: "/service/ui-ux-design",
      text: "Design",
    },
  },
  {
    id: 4,
    name: "Platform",
    title: "Reliable paths to production",
    description:
      "Environments, pipelines, and observability set up so releases are repeatable and incidents are traceable — without turning ops into a second product.",
    cta: {
      href: "/service/devops",
      text: "Platform & DevOps",
    },
  },
];
